module.exports = __webpack_public_path__ + "img/syl_gallery4.2016c91d.jpg";